<template>
    <div v-if="medic && medic.fl_suspenso">
        <span class="badge badge-danger">
            Suspenso
        </span>
        <span class="small text-muted ml-1" v-if="medic.st_suspenso_obs">
            <template v-if="medic.dt_suspenso">{{ $util.getFormatDate(medic.dt_suspenso, 'DD/MM') }} {{ medic.dt_suspenso.slice(11,16) }}</template>
            | {{ medic.st_suspenso_obs }}
        </span>
    </div>
</template>

<script>
export default {
    props: ['medic'],
}
</script>

